import { IOS_APP_USER_AGENT, ANDROID_APP_USER_AGENT, X_CHANNEL_IM_SHELL, X_CHANNEL_TOING } from "../constants";

export const isIos = (platform: string): boolean => {
    return platform.toLowerCase() === IOS_APP_USER_AGENT;
};

export const isAndroid = (platform: string): boolean => {
    return platform.toLowerCase() === ANDROID_APP_USER_AGENT;
};

export const isImShell = (xChannel = ""): boolean => {
    return xChannel === X_CHANNEL_IM_SHELL;
};

export const isToingApp = (xChannel = ""): boolean => {
    return xChannel?.toLowerCase() === X_CHANNEL_TOING.toLowerCase();
};
